<script setup lang="ts">
import LazyImage from '~/components/LazyImage.vue';
import VideoPlayer from './VideoPlayer.vue';
import { MediaType, VideoType } from './types';

interface Props {
	videoUrl?: string;
	src: string;
	alt: string;
	type: MediaType;
	isActive: boolean;
	poster?: string;
}
const props = defineProps<Props>();

const videoType = computed(() => {
	if (props.type !== MediaType.VIDEO) return;
	return props.src.includes('.m3u8') ? VideoType.HLS : VideoType.CONVENTIONAL;
});
</script>

<template>
	<LazyImage
		v-if="type === MediaType.IMAGE"
		:src="src"
		:alt="alt"
		:width="isMobileView() ? 300 : 500"
		class="lg:rounded-xl"
		loading="lazy"
	/>

	<div
		v-if="type === MediaType.VIDEO"
		class="aspect-[5/7] relative flex justify-center lg:rounded-xl overflow-clip size-full"
	>
		<LazyImage
			v-if="poster"
			:src="poster"
			:alt="alt"
			:width="isMobileView() ? 300 : 500"
			class="object-cover blur-md"
			loading="lazy"
		/>
		<VideoPlayer
			class="absolute size-full flex items-center justify-center"
			:video-url="props.videoUrl"
			:src="src"
			:poster="poster"
			:is-playing="isActive"
			:video-type="videoType"
		/>
	</div>
</template>
